import { doRequest } from '@r1-frontend/do-request';
import { ISeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';
import { ISeasonTicketFlags, seasonTicketFlags } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/flags';

import { TDispatch, TGetState } from '~/src/store';
import { setLoadingStatus, setWholesaleCheaperData } from '~/src/store/actionCreators/wholesaleCheaper';

const transformSeasonTickets = (_seasonTicketFlags: ISeasonTicketFlags): ISeasonTicket => {
    const { currentFlag, availableFlags } = _seasonTicketFlags;

    return {
        currentFlag: currentFlag.map(el => ({ ...el, paySum: 0 })),
        availableFlags: availableFlags.map(el => ({ ...el, paySum: 0 })),
    };
};

export const fetchSeasonTickets = () => {
    return async(dispatch: TDispatch, getState: TGetState): Promise<void> => {
        dispatch(setLoadingStatus(true));

        const {
            city: { provider: { providerId } },
        } = getState();

        const response = await doRequest.apiSeasonTicket<ISeasonTicketFlags>(seasonTicketFlags(providerId));

        if (response.isSuccess) {
            const seasonTickets = transformSeasonTickets(response.payload);
            dispatch(setWholesaleCheaperData(seasonTickets));
        } else {
            dispatch(setWholesaleCheaperData(undefined));
        }

        dispatch(setLoadingStatus(false));
    };
};
